export default __webpack_public_path__ + "static/media/backgroundLogoConcorrencia.2be9bd7a.svg";